<template>
  <div class="search-form">
    <a-form-model v-if="fields.length" ref="searchFrom" layout="inline" :model="form">
      <!-- field.widthNum? 'ant-input': 'auto' -->
      <template v-for="field in fields">
        <a-form-model-item :key="field.name">
          <a-input
            v-if="field.type === 'text'"
            :placeholder="field.placeholder"
            v-model="form[field.name]"
            allow-clear
            @change="e => textChange(e, field.name)"
            @keyup.enter="handleSubmit('submit')"
            :style="{ width: field.width || '180px' }"
          />

          <a-input-search
            v-if="field.type === 'text-search'"
            v-model="form[field.name]"
            :placeholder="field.placeholder"
            allow-clear
            @keyup.enter="handleSubmit('submit')"
            :style="{ width: field.width || '190px' }"
          />

          <a-select
            allow-clear
            :mode="field.type === 'multiple' ? 'multiple':'default'"
            v-if="field.type === 'select' || field.type === 'multiple'"
            v-model="form[field.name]"
            :showSearch="field.isSearch"
            :getPopupContainer="field.getPopupContainer || (() => $el)"
            :filter-option="false"
            :placeholder="field.placeholder"
            :options="field.options"
            :maxTagCount="field.maxTagCount || undefined"
            @change="selectFun"
            @search="searchFun"
            :dropdownMatchSelectWidth="true"
            :style="{ width: field.width || '200px' }"
          />

          <a-range-picker
            v-if="field.type === 'range-picker'"
            v-model="form[field.name]"
            :autoFocus="false"
            separator="-"
            :placeholder="field.placeholder"
            format="YYYY-MM-DD"
            :style="{ width: '260px' }"
            :disabled-date="field.disabledDate"
            :getCalendarContainer="() => $parent.$el"
          >
            <a-icon slot="suffixIcon" type="calendar" />
          </a-range-picker>

          <a-tree-select
            v-if="field.type === 'tree-select'"
            v-model="form[field.name]"
            allow-clear
            :treeDefaultExpandedKeys="['1']"
            :tree-data="field.options"
            :placeholder="field.placeholder"
            :style="{ width: '220px' }"
            :dropdown-style="{ maxHeight: '500px', overflow: 'auto' }"
          ></a-tree-select>
        </a-form-model-item>
      </template>
      <slot></slot>
      <a-form-model-item>
        <a-button type="primary" @click="handleSubmit('submit')">{{$t('common_btn_search')}}</a-button>
      </a-form-model-item>

    </a-form-model>
  </div>
</template>

<script>
import { TreeSelect } from 'ant-design-vue'
import moment from 'moment'

export default {
  name: 'SearchForm',
  components: {
    ATreeSelect: TreeSelect
  },
  props: {
    fields: {
      type: Array,
      default () {
        return []
      }
    },
    isDownBtn: {
      type: Boolean,
      default: false
    },
    searchFrom: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      callSearch: '',
      form: JSON.parse(JSON.stringify(this.searchFrom))
    }
  },
  methods: {
    moment,
    handleSubmit (type) {
      const {
        $props: { fields },
        $data: { form },
        $refs: { searchFrom }
      } = this
      const val = { ...form }
      searchFrom.validate(() => {
        // 处理alias
        const aliasItems = fields.filter((field) => field.alias)

        aliasItems.forEach((item) => {
          const { type, alias, name } = item

          if (Array.isArray(alias)) {
            alias.forEach((aliasName, index) => {
              if (
                type === 'range-picker' &&
                (aliasName === 'startDate' || aliasName === 'start')
              ) {
                val[aliasName] =
                  form[name] &&
                  form[name][index] &&
                  moment(form[name][index]).startOf('day')
              } else if (
                type === 'range-picker' &&
                (aliasName === 'endDate' || aliasName === 'end')
              ) {
                val[aliasName] =
                  form[name] &&
                  form[name][index] &&
                  moment(form[name][index]).endOf('day')
              } else {
                val[aliasName] = form[name] && form[name][index]
              }
            })
          } else {
            val[alias] = form[name]
          }

          delete val[name]
        })

        this.$emit(type, val)
      })
    },
    getFields (aliasItems = []) {
      const { form } = this
      const val = { ...form }
      aliasItems.forEach((item) => {
        const { type, alias, name } = item
        if (Array.isArray(alias)) {
          alias.forEach((aliasName, index) => {
            if (type === 'range-picker' && aliasName === 'startDate') {
              val[aliasName] =
                form[name] &&
                form[name][index] &&
                moment(form[name][index]).startOf('day')
            } else if (type === 'range-picker' && aliasName === 'endDate') {
              val[aliasName] =
                form[name] &&
                form[name][index] &&
                moment(form[name][index]).endOf('day')
            } else {
              val[aliasName] = form[name] && form[name][index]
            }
          })
        } else {
          val[alias] = form[name]
        }

        delete val[name]
      })
      return val
    },
    init () {
      const { fields } = this
      const form = {}

      if (fields.length > 0) {
        fields.forEach((item) => {
          // 给表单赋值
          if (item.hasOwnProperty('value') && item.value) {
            form[item.name] = item.value
          }
        })
      }
      this.form = { ...this.form, ...form }
    },
    selectFun (value) {
      console.log(`Selected: ${value}`)
    },
    searchFun (value) {
      this.$EventBus.$emit('getTarget', value)
      // console.log(`Selected: ${value}`)
    },
    cancal () {
      this.form = {}
      // this.$refs['searchFrom'].resetFields()
      this.$forceUpdate()
    },
    textChange (val, name) {
      if (this.form[name]) {
        this.form[name] = this.form[name].trim()
      }
    }
  },
  watch: {
    fields: {
      handler: 'init',
      immediate: true
    }
  },
  beforeDestroy () {
    this.$EventBus.$off('getTarget')
  }
}
</script>

<style lang="less" scoped>
  .ant-drawer-body .search-form, .ant-modal .search-form {
    // padding: 0 0 4px 0;
    background: transparent !important;
  }
  .search-form {
    display: flex;
    margin-bottom: 12px;
    .ant-form {
      flex: 1;
      .ant-form-item {
        margin-right: 8px;
        font-size: 12px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .down-submit {
      width: 30px;
      height: 30px;
      border-radius: 2px;
      border: 1px solid #D9D9D9;
      cursor: pointer;
      &:hover {
        border: 1px solid #077BFC;
        .icon-svg {
          color: #077BFC;
        }
      }
      &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        .icon-svg {
          color: rgba(0,0,0,0.45);
        }
      }
      // cursor: pointer;
    }
  }
  .ant-select::-webkit-scrollbar {
    display: none;
  }
  /deep/ .ant-form-item-control{
    line-height: unset;
  }
  /deep/ .ant-select-selection--multiple {
    overflow-y: auto;
    position: relative;
    height: 32px;
    padding-bottom: 0
  }
  /deep/.ant-input {
    height: 30px;
    font-size: 12px;
    width: 100%;
    border-radius: 2px;
    color: rgba(0,0,0,0.85);
  }

  /deep/.ant-select {
    font-size: 12px;
  }
  /deep/.ant-select-selection {
    border-radius: 2px;
  }
  /deep/.ant-select-selection-selected-value {
    color: rgba(0,0,0,0.85);
  }
  /deep/.ant-select-selection--single {
    height: 30px;
  }
  /deep/.ant-select-selection__rendered {
    line-height: 28px;
  }
  /deep/.ant-btn {
    padding: 0 10px;
    min-width: 50px;
    height: 30px;
    font-size: 12px;
    border-radius: 2px;
    border: none;
    letter-spacing: normal;
    text-shadow: none;
  }
  /deep/.ant-select-dropdown-menu-item {
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    line-height: 20px;
    &:hover {
      background: rgba(7,123,252,0.06);
    }
  }
  /deep/.anticon {
    font-size: 12px;
  }
</style>
